/**
 * Block 2 commit 2a (Sebastian ruling 2026-08-31 evening) — read-only
 * status screen for the eleven post-render + post-checkout book states
 * that previously fell to BookRoute's default fallback (WaitScreen with
 * "Wir zeichnen dein Titelbild." — misleading for every one of them).
 *
 * Shape: two Sebastian-authored strings per screen, heading + subtitle.
 * No action, no button, no CTA. Every consumer is read-only — the
 * customer waits for an email, or has already received one.
 *
 * Distinct from WaitScreen: WaitScreen carries a progressbar + a
 * "teaserLead" (long-form marketing prose) + a "beruhigungszeile"
 * (small muted line). Status info screens carry ONLY heading +
 * subtitle in the same primary type, so the subtitle sits at the same
 * weight as WaitScreen's teaser without the pre-render Wartemoment
 * framing.
 *
 * The `data-testid` allows PWA e2e assertions to check the container
 * without wiring per-state testids everywhere.
 *
 * Sebastian ruling 2026-09-08 evening (Commit 2 of A+B+C) — `subtitle`
 * accepts a readonly string[] for screens whose released copy spans
 * multiple paragraphs (specifically `book_release_chain_error`). Each
 * array entry renders as its own `<p>` with matching type at the same
 * navy color as the single-string branch. Backwards-compat: existing
 * single-string callers pass a string as before, no visual change.
 */
export interface BookStatusInfoScreenProps {
  readonly heading: string;
  readonly subtitle: string | readonly string[];
}

export function BookStatusInfoScreen({ heading, subtitle }: BookStatusInfoScreenProps) {
  const paragraphs = typeof subtitle === 'string' ? [subtitle] : subtitle;
  return (
    <div className="flex flex-col items-center pt-6 pb-4" data-testid="book-status-info-screen">
      <h1 className="mb-4 text-center text-base font-semibold text-dream-navy">{heading}</h1>
      {paragraphs.map((paragraph, index) => (
        <p
          key={index}
          className={
            index === 0
              ? 'text-center text-base text-dream-navy'
              : 'mt-4 text-center text-base text-dream-navy'
          }
        >
          {paragraph}
        </p>
      ))}
    </div>
  );
}
